import React from "react";
import { SmsTosConsentAlreadyAcceptedScreen } from "~/features/tos-consent/SmsTosConsentAlreadyAcceptedScreen";

const Component = () => {
  return <SmsTosConsentAlreadyAcceptedScreen />;
};

export default Component;
